import instance from './axiosInstance';

export const getRCAData = (reqBody) => {
  return instance.post('/appData/rca', reqBody);
};
